import React, { useState } from "react";
import img1 from "../../common/images/Crm-bg-d-1.png";
import img2 from "../../common/images/Crm-bg-d-2.png";
import img3 from "../../common/images/Crm-bg-d-3.png";
import img4 from "../../common/images/Crm-bg-d-4.png";
import img5 from "../../common/images/Crm-bg-d-5.png";
import img6 from "../../common/images/Crm-bg-d-6.png";

import ico1 from "../../common/images/crm-yico-1.png";
import ico2 from "../../common/images/crm-yico-6.png";
import ico3 from "../../common/images/crm-yico-3.png";
import ico4 from "../../common/images/crm-yico-4.png";
import ico5 from "../../common/images/crm-yico-5.png";
import ico6 from "../../common/images/crm-yico-2.png";

import ico1h from "../../common/images/crm-ico-h1.png";
import ico2h from "../../common/images/crm-ico-h2.png";
import ico3h from "../../common/images/crm-ico-h6.png";
import ico4h from "../../common/images/crm-ico-h5.png";
import ico5h from "../../common/images/crm-ico-h4.png";
import ico6h from "../../common/images/crm-ico-h3.png";

import Min from "../../common/images/main-crm.png";

const features = [
  {
    id: 1,
    title: "Project Management",
    description:
      "Track the progress of all projects, assign team members, set deadlines, and monitor completion status.",
    icon: ico1,
    iconHover: ico1h,
    bg: img1,
  },
  {
    id: 2,
    title: "Team Collaboration",
    description: "Centralize communication and assign tasks to team members with real-time updates.",
    icon: ico2,
    iconHover: ico2h,
    bg: img2,
  },
  {
    id: 3,
    title: "Task Scheduling",
    description:
      "Create, assign, and monitor tasks to ensure timely completion.",
    icon: ico3,
    iconHover: ico5h,
    bg: img3,
  },
  {
    id: 4,
    title: "Resource Allocation",
    description: "Manage team workload, track productivity, and adjust assignments to avoid burnout.",
    icon: ico4,
    iconHover: ico4h,
    bg: img4,
  },
  {
    id: 5,
    title: "Performance Tracking",
    description: "Generate performance reports to analyze project success rates and team efficiency.",
    icon: ico5,
    iconHover: ico3h,
    bg: img5,
  },
  {
    id: 6,
    title: "Client & Customer Support",
    description: "Manage client requests, automate follow-ups, and resolve issues efficiently.",
    icon: ico6,
    iconHover: ico6h,
    bg: img6,
  },
];

const CRMFeatures = () => {
  const [selected, setSelected] = useState(features[0]);
  const [hoveredId, setHoveredId] = useState(null);

  return (
    <section className="py-7 md:px-10 px-5 max-w-[1280px] mx-auto">
      <div className="text-center mb-10">
        <h2 className="md:text-5xl small:text-3xl text-2xl font-bold small:w-[70%] mx-auto">
          CRM for Office and Business Management
        </h2>
        <div className="underline md:w-1/5 w-2/5 flex justify-center mx-auto my-4 items-center h-[2px] rounded-md bg-black">
          <p className="h-[5px] rounded-xl bg-primary md:w-[50%] w-[70%]"></p>
        </div>
        <p className="text-black small:text-[16px] text-sm small:w-[60%] mx-auto">
          Our CRM solutions are designed to enhance office and business
          management by providing a structured platform to organize and oversee
          operations efficiently.
        </p>
      </div>

      <div className="flex small:flex-row flex-col gap-5 max-w-[1280px] mx-auto">
        {/* Left Side - Selected Feature */}
        <div className="text-white p-6 small:flex-[0.5] flex-1 min-h-[200px] rounded-xl relative">
          <img
            src={Min}
            alt={selected.title}
            className="absolute inset-0 w-full h-full object-fill rounded-xl"
          />
          <div className="relative size-full flex flex-col justify-end z-10">
            <h3 className="text-xl sm:text-2xl font-semibold mb-2">
              {selected.title}
            </h3>
            <p className="text-sm sm:text-base text-white">
              {selected.description}
            </p>
          </div>
        </div>

        {/* Right Side - Grid */}
        <div className="flex-1 grid grid-cols-1 sm:grid-cols-2 gap-4">
        {features.map((feature) => (
  <div
    key={feature.id}
    onClick={() => setSelected(feature)}
    onMouseEnter={() => setHoveredId(feature.id)}
    onMouseLeave={() => setHoveredId(null)}
    className={`text-white p-7 cursor-pointer flex items-center gap-3 relative overflow-hidden transition-all duration-300 rounded-[13px] ${ 
        hoveredId === feature.id
          ? "rounded-br-[50px]"
          : ""
      }`}
    style={{
      backgroundImage: `url(${feature.bg})`,
      backgroundSize: "cover",
      backgroundPosition: "center",
    }}
  >
    {/* Yellow hover overlay */}
    <div
      className={`absolute inset-0 transition-all duration-300 ${
        hoveredId === feature.id
          ? "bg-[#1c2124b8] opacity-[0.56] rounded-br-[50px]"
          : "opacity-0"
      }`}
    />

    <img
      src={hoveredId === feature.id ? feature.iconHover : feature.icon}
      alt={feature.title}
      className="size-[65px] z-10"
    />
    <span className="font-semibold z-10 text-lg px-5">
      {feature.title}
    </span>
  </div>
))}


        </div>
      </div>
    </section>
  );
};

export default CRMFeatures;
